[
  {
    "title": "1. Sponsor and charitable purpose",
    "paragraphs": [
      "The Light the Future 50/50 Raffle (“Raffle”) is conducted by Smithfield Little League (“SLL”), a charitable youth-sports organization. Net proceeds retained by SLL will support field improvements, equipment, programs, and other charitable purposes benefiting Smithfield Little League and its players."
    ]
  },
  {
    "title": "2. Eligibility",
    "paragraphs": [
      "Participants must be at least eighteen (18) years old at the time of purchase.",
      "By purchasing an entry, the purchaser confirms that the purchaser:",
      "Is at least eighteen years old;",
      "Meets all applicable eligibility and purchase requirements;",
      "Has provided accurate contact information; and",
      "Agrees to these Official Rules.",
      "SLL may request proof of age and identity before awarding the prize. A purchaser who cannot establish eligibility may be disqualified.",
      "SLL reserves the right to prohibit any person directly responsible for administering the drawing, reconciling the entries, or selecting the winner from participating in the Raffle."
    ]
  },
  {
    "title": "3. Raffle period",
    "paragraphs": [
      "Raffle sales will close on October 8, 2026, at 7:40PM Eastern Time.",
      "The drawing is expected to take place on October 8, 2026, at approximately 8:00PM during the Smithfield Little League Annual Banquet at Wright’s Farm in Burrillville, Rhode Island.",
      "SLL may announce a short extension of the sales period before the drawing when reasonably necessary to complete sales already in progress or resolve an operational issue. No entries will be sold or accepted after the drawing begins."
    ]
  },
  {
    "title": "4. How to enter",
    "paragraphs": [
      "Eligible participants may purchase Raffle entries:",
      "Through the authorized online purchase form designated by SLL; or",
      "In person from an authorized SLL representative.",
      "Entries will be offered according to the following schedule:",
      "$1 for 1 entry or entries",
      "$10 for 20 entries",
      "$20 for 50 entries",
      "An entry is valid only after SLL receives and confirms the required payment. Entries associated with declined, reversed, disputed, incomplete, fraudulent, or otherwise unsuccessful payments are invalid and may be removed before the drawing.",
      "All purchases are final except when SLL cancels the Raffle, cannot provide the purchased entries, or determines that a refund is necessary to correct an administrative or payment error."
    ]
  },
  {
    "title": "5. Entry numbers and drawing tickets",
    "paragraphs": [
      "Each valid entry will receive a unique Raffle number.",
      "For an online purchase, SLL will assign the entry numbers after confirming the order and will send them to the purchaser using the email address provided with the purchase. Failure to receive or open the confirmation email does not invalidate properly recorded entries.",
      "Each valid online and in-person entry will be represented in the physical drawing. All entries will be placed into the same drawing pool and will have an equal chance of being selected.",
      "The purchaser is responsible for providing accurate contact information. SLL is not responsible for confirmation messages that are delayed, filtered, rejected, or sent to an incorrectly entered address.",
      "SLL’s official Raffle ledger will control if a discrepancy exists between a purchaser’s receipt, confirmation message, physical ticket, or other record."
    ]
  },
  {
    "title": "6. Prize",
    "paragraphs": [
      "The base prize will equal fifty percent (50%) of the eligible gross Raffle sales received before the sales cutoff.",
      "The remaining fifty percent (50%), less any lawful and reasonable expenses associated with conducting the Raffle, will be retained by SLL for its charitable purposes.",
      "The estimated prize amount displayed or announced before sales close is unofficial and may change as additional sales are received, payments are reconciled, or invalid transactions are removed. SLL’s final reconciled sales record will determine the official base prize."
    ]
  },
  {
    "title": "7. Edward Jones sponsor bonus",
    "paragraphs": [
      "The winning participant may also receive a sponsor-funded bonus provided by Ben Vincent, CFP | Edward Jones.",
      "The bonus will equal:",
      "$100 when eligible gross Raffle sales reach $1,000;",
      "$200 when eligible gross Raffle sales reach $2,000;",
      "$300 when eligible gross Raffle sales reach $3,000;",
      "$400 when eligible gross Raffle sales reach $4,000;",
      "$500 when eligible gross Raffle sales reach $5,000;",
      "$600 when eligible gross Raffle sales reach $6,000;",
      "$700 when eligible gross Raffle sales reach $7,000;",
      "$800 when eligible gross Raffle sales reach $8,000;",
      "$900 when eligible gross Raffle sales reach $9,000;",
      "$1,000 when eligible gross Raffle sales reach $10,000 or more.",
      "The maximum sponsor bonus is $1,000. Partial $1,000 sales increments do not produce a partial bonus.",
      "The sponsor bonus is paid in addition to the winner’s fifty-percent share and does not reduce the portion retained by SLL.",
      "Edward Jones and Ben Vincent do not administer the Raffle, select the winner, sell entries, or control the use of SLL’s proceeds. The sponsor bonus is subject to the final written sponsorship commitment and applicable law."
    ]
  },
  {
    "title": "8. Winner selection",
    "paragraphs": [
      "One winning entry will be selected at random from all valid entries included in the drawing.",
      "The drawing will be supervised by designated SLL representatives. SLL may also designate an independent witness to observe the reconciliation of entries and the drawing.",
      "Before the winning entry is announced, SLL may verify that:",
      "The selected entry appears in the official ledger;",
      "Payment for the entry was successfully received;",
      "The entry was included before the sales deadline; and",
      "The purchaser satisfies the eligibility requirements.",
      "The drawing result is final, subject to verification of eligibility and compliance with these Official Rules."
    ]
  },
  {
    "title": "9. Winner notification and prize claim",
    "paragraphs": [
      "The winner WILL NOT be required to be present at the drawing.",
      "If the winner is present, SLL may announce the winning number and begin verification immediately. If the winner is not present or does not claim the prize at the event, SLL will attempt to contact the winner using the telephone number or email address associated with the winning entry.",
      "The winner must claim the prize and provide any reasonably requested identification, eligibility verification, tax information, or acknowledgment documentation within 30 days after the drawing.",
      "If the selected winner is ineligible, declines the prize, cannot be located after reasonable attempts, or fails to claim the prize by the deadline, SLL may select an alternate winner through another random drawing from the remaining valid entries, subject to applicable law and licensing instructions.",
      "The prize will be paid by check unless SLL approves another lawful payment method. SLL will not divide the prize among multiple persons. When an entry was purchased on behalf of a group, the person identified in SLL’s official ledger will be treated as the winner and will be solely responsible for distributing any portion of the prize to other group members."
    ]
  },
  {
    "title": "10. Taxes",
    "paragraphs": [
      "The winner is solely responsible for all federal, state, and local taxes associated with the prize. SLL may require the winner to complete applicable tax forms and may report or withhold amounts when required by law.",
      "The advertised or announced prize amount is the gross prize before any required tax withholding."
    ]
  },
  {
    "title": "11. Errors and disputes",
    "paragraphs": [
      "SLL will make reasonable efforts to ensure that all valid purchases are accurately recorded and included in the drawing.",
      "If a printing, numbering, payment, transmission, clerical, or technical error occurs, SLL may correct its records, replace an affected entry, issue a refund, delay the drawing, or take another reasonable action necessary to protect the fairness and integrity of the Raffle.",
      "Possession of a ticket or confirmation containing an error does not entitle the holder to a prize if the corresponding purchase is not validly recorded in SLL’s official ledger.",
      "Questions or disputes will be reviewed by designated SLL officers. Their decisions will be final to the extent permitted by law and remain subject to any direction from the applicable Rhode Island or local licensing authority."
    ]
  },
  {
    "title": "12. Cancellation or postponement",
    "paragraphs": [
      "SLL may postpone, modify, suspend, or cancel the Raffle if required by law, a licensing authority, severe weather, venue restrictions, technical failure, fraud, safety concerns, or circumstances that prevent the Raffle from being conducted fairly.",
      "If the Raffle is canceled without a drawing, SLL will make reasonable efforts to refund valid purchases.",
      "If the banquet is postponed or relocated, SLL may conduct the drawing at a revised time or location after providing reasonable notice through its website, email, social-media channels, or an announcement to participants."
    ]
  },
  {
    "title": "13. Publicity and privacy",
    "paragraphs": [
      "SLL will use purchaser information to administer the Raffle, issue confirmations, contact the winner, satisfy legal requirements, and maintain required financial records.",
      "Except as required by law, SLL will not publicly disclose non-winning purchasers’ personal information.",
      "By accepting the prize, the winner authorizes SLL to publish the winner’s name, hometown, photograph, and prize amount for legitimate Raffle reporting and promotional purposes, unless prohibited by law."
    ]
  },
  {
    "title": "14. General conditions",
    "paragraphs": [
      "The Raffle is void where prohibited by law.",
      "Entries may not be transferred or resold after purchase. Any attempted manipulation, duplication, alteration, interference, fraud, or circumvention of the Raffle process may result in disqualification.",
      "SLL’s failure to enforce a particular provision of these Official Rules does not waive its right to enforce that provision later.",
      "If any provision is found invalid or unenforceable, the remaining provisions will continue in effect.",
      "The Raffle will be governed by the laws of the State of Rhode Island and any conditions imposed by the Rhode Island State Police, the applicable local licensing authority, or another governmental authority with jurisdiction."
    ]
  },
  {
    "title": "15. Contact information",
    "paragraphs": [
      "Questions concerning the Raffle may be directed to:",
      "Smithfield Little League",
      "PO Box 17093, Smithfield, RI 02917",
      "jay@smithfieldlittleleague.org",
      "A copy of these Official Rules will be available through the authorized Raffle website and upon request from Smithfield Little League.",
      "Effective date: 9/8/2026"
    ]
  }
]
